import * as log from 'loglevel';
import Api from './Api';

// import User from './User';

class Episode extends Api {
  getEpisodesById(id) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/episodes', { uuids: id }).then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getListenedEpisodes() {
    return new Promise((resolve, reject) => {
      super.getList('/v1/episodes_listen').then((resp) => {
        resolve(resp);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getEpisodeProgressFromLocalStore(episodeUuid) {
    const episodeProgress = window.$store.getters.episodeProgressByUuid(episodeUuid);

    if (episodeProgress) {
      return episodeProgress;
    }

    return null;
  }

  // Checks for episode progress locally, if not found, gets via API
  getEpisodeProgress(episodeUuid) {
    const episodeProgress = window.$store.getters.episodeProgressByUuid(episodeUuid);

    return new Promise((resolve, reject) => {
      if (episodeProgress) {
        resolve(episodeProgress);
      } else {
        this.checkEpisodeProgress(episodeUuid)
          .then((value) => {
            resolve(value.episode);
            window.$store.dispatch('setEpisodeProgressById', value.episode);
          })
          .catch((error) => {
            reject(error);
          });
      }
    });
  }

  getEpisodeById(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1/episodes/{episode_uuid}', { episode_uuid: id }).then((resp) => {
      // super.get('/episodes/{episode_uuid}', { episode_uuid: id }).then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getEpisodeBySlug(slug) {
    return new Promise((resolve, reject) => {
      super.get('/v1/episodes/slug/{episode_slug}', { episode_slug: slug }).then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  checkEpisodeProgress(episodeId) {
    return new Promise((resolve, reject) => {
      super.get('/v1/episode_listens/{episode_uuid}', { episode_uuid: episodeId }).then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAllPlayedEpisodes() {
    return new Promise((resolve, reject) => {
      super.get('/v1/playlist', { playlist_type: 'continue_listening' }).then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getLastPlayedEpisode() {
    return new Promise((resolve, reject) => {
      super.get('/v1/episode_listens/last_played').then((resp) => {
        resolve(resp);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // getEpisodesBySeasonId(seasonUUID) {
  //   return new Promise((resolve, reject) => {
  //     super.get('seasons', seasonUUID).then(resp => {
  //       resolve(resp)
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  //   })
  // }

  playLastPlayedEpisode() {
    const getLastPlayedEpisode = this.getLastPlayedEpisode();
    getLastPlayedEpisode.then((resp) => {
      if (resp && resp.episode && resp.episode.episode_uuid) {
        this.getEpisodeById(resp.episode.episode_uuid, {}).then((episode) => {
          if (episode) {
            let tempTitle = 'All Caught Up';
            const progress = this.getEpisodeProgressFromLocalStore(episode.uuid) || 1;
            if (progress.progress_percent < 95) {
              tempTitle = 'Resume Episode';
            } else if (progress.progress_percent >= 95) {
              tempTitle = 'Play Next Episode';
            }
            episode.temp_title = tempTitle;
            window.$store.dispatch('setIsLastPlayed', episode.uuid);
            window.$store.dispatch('setEpisode', episode);
          }
        });
      }
    });
  }

  stringifyObj(obj) {
    return Object.keys(obj).reduce((a, k) => { a.push(`${k}=${encodeURIComponent(obj[k])}`); return a; }, []).join('&');
  }

  savePlayProgress(episodeId, progress, duration, podcastUuid, episodeType) {
    // let formData = this.stringifyObj({
    //   "episode_uuid": episodeId,
    //   "elapsed": progress.toString(),
    //   "runtime": duration.toString()
    // })
    // let headers =  {
    //   "Content-Type": "application/x-www-form-urlencoded"
    // }
    return new Promise((resolve, reject) => {
      const { token } = window.$store.getters;
      if (!token) {
        reject(new Error('User is not loggedIn'));
        return;
      }
      const formData = {
        episode_uuid: episodeId,
        elapsed: progress.toString(),
        runtime: duration.toString(),
        podcast_uuid: podcastUuid,
        episode_type: episodeType,
      };
      super.post('/v1/episode_listens', formData).then(() => {
        resolve();
      }, (error) => {
        log.warn(error);
        reject(error);
      });
    });
  }

  async getEpisodesFromLibrary(limit, page) {
    return new Promise((resolve, reject) => {
      super.getList('/v1/user/episode', { limit, p: page })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async addEpisodetoLibrary(id) {
    return new Promise((resolve, reject) => {
      const formData = {
        episode_uuid: id,
      };
      super.post('/v1/user/episode', formData)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async deleteEpisodeFromLibrary(id) {
    return new Promise((resolve, reject) => {
      const params = {
        user_episode_uuid: id,
      };
      super.delete('/v1/user/episode/{user_episode_uuid}', params)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateEpisodePosition(id, pos) {
    return new Promise((resolve, reject) => {
      const params = {
        user_episode_uuid: id,
        position: pos,
      };
      super.put('/v1/user/episode/{user_episode_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  giveEpisodeFeedback(id, comments) {
    return new Promise((resolve, reject) => {
      const params = {
        episode_uuid: id,
        content: comments,
      };
      super.post('/v1/user/episode_feedback/{episode_uuid}', params)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getEpisodeFeedback(id) {
    return new Promise((resolve, reject) => {
      super.get('/v1/user/episode_feedback/{episode_uuid}', { episode_uuid: id })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAllPodcastEpisodes(_limit, _page) {
    return new Promise((resolve, reject) => {
      super.get('/v1.1/user/podcast/episodes', { limit: _limit, p: _page })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getUserLibraryEpisodeIds() {
    return new Promise((resolve, reject) => {
      super.get('/v1/user/library/episodeids')
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getEdpEpisodes(id) {
    return new Promise((resolve, reject) => {
      super.getList('/v1.1/episode/{episode_uuid}/episodes', { episode_uuid: id })
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default Episode;



// WEBPACK FOOTER //
// ./app/src/services/Episode.js